import React from 'react';
import styled from 'styled-components';
import { Grid } from 'planoplan-ui-kit/core/helpers/grid';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { Points, textSize } from '@styles';
import { useTranslations } from '@libs/translations';

export const Top = () => {
  const translations = useTranslations();

  return (
    <Container>
      <Title>{translations.t(`site.distributors.pageTitle`)}</Title>
      <Description>{translations.t(`site.distributors.pageTopDescription`)}</Description>
    </Container>
  );
};

const Container = styled.section`
  ${Grid.suffix(2)};
  ${Grid.prefix(2)};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding-top: 55px;
  padding-bottom: 60px;

  @media ${Points.tablet_portrait} {
    padding-top: 45px;
    padding-bottom: 70px;
  }

  @media ${Points.laptop_wide} {
    padding-top: 70px;
    padding-bottom: 80px;
  }

  @media ${Points.fullhd} {
    padding-top: 80px;
    padding-bottom: 90px;
  }
`;

const Title = styled.h1`
  margin-bottom: 20px;
  ${textSize('page_header')};
  color: ${Colors.main_black};
  font-weight: 200;
  text-align: center;

  @media ${Points.laptop_wide} {
    margin-bottom: 30px;
  }
`;

const Description = styled.p`
  margin: 0 auto;
  display: block;
  text-align: center;
  color: ${Colors.main_gray};
  ${textSize('body')};
  font-weight: 400;

  @media ${Points.tablet_landscape} {
    width: 568px;
  }

  @media ${Points.laptop_wide} {
    width: 640px;
  }

  &:last-child {
    margin-bottom: 0;
  }
`;
